import { render, staticRenderFns } from "./Datasheet.vue?vue&type=template&id=863a987a&scoped=true&"
import script from "./Datasheet.vue?vue&type=script&lang=js&"
export * from "./Datasheet.vue?vue&type=script&lang=js&"
import style0 from "./Datasheet.vue?vue&type=style&index=0&id=863a987a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863a987a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VIcon,VImg})
